<ng-container *ngIf="data.job$ | async as job">
  <div class="progress-dialog">
    <header>
      <div>
        <h2>{{ statusLabel(job) }}</h2>
        <p>{{ objectSummary(job) }}</p>
      </div>
      <button mat-icon-button type="button" [attr.aria-label]="'Minimize ' + noun + ' push progress'" (click)="minimize()">
        <mat-icon>remove</mat-icon>
      </button>
    </header>

    <section class="stage">
      <div class="stage-row">
        <strong>{{ job.stage }}</strong>
        <span>{{ job.progressPercent }}%</span>
      </div>
      <mat-progress-bar mode="determinate" [value]="job.progressPercent"></mat-progress-bar>
      <p class="destination" *ngIf="job.currentLocationName; else waiting">
        Current: {{ job.currentOrganizationName }} / {{ job.currentLocationName }}
      </p>
      <ng-template #waiting>
        <p class="destination" *ngIf="!isTerminal(job)">Waiting for the next location…</p>
      </ng-template>
      <p>{{ job.processedLocations }} of {{ job.totalLocations }} processed</p>
    </section>

    <section class="counts" [attr.aria-label]="noun + ' push counts'">
      <div><strong>{{ job.successfulLocations }}</strong><span>Successful</span></div>
      <div><strong>{{ job.failedLocations }}</strong><span>Failed</span></div>
      <div><strong>{{ job.skippedLocations }}</strong><span>Skipped</span></div>
      <div><strong>{{ job.remainingLocations }}</strong><span>Remaining</span></div>
    </section>

    <p class="job-error" *ngIf="job.errorMessage">{{ job.errorMessage }}</p>

    <section class="issues" *ngIf="job.failures?.length">
      <h3>Failures and skipped locations</h3>
      <article *ngFor="let issue of job.failures">
        <strong>{{ issue.organizationName }} / {{ issue.locationName }}</strong>
        <p>{{ issue.message }}</p>
      </article>
    </section>

    <section class="issues warnings" *ngIf="job.warnings?.length">
      <h3>Warnings</h3>
      <article *ngFor="let issue of job.warnings">
        <strong>{{ issue.organizationName }} / {{ issue.locationName }}</strong>
        <p>{{ issue.message }}</p>
      </article>
    </section>

    <footer>
      <button mat-button type="button" (click)="minimize()">Minimize</button>
      <button mat-stroked-button color="warn" type="button" *ngIf="job.canCancel" [disabled]="actionInProgress" (click)="cancel(job)">
        Cancel remaining
      </button>
      <button mat-stroked-button color="primary" type="button" *ngIf="job.canRetry" [disabled]="actionInProgress" (click)="retry()">
        Retry failed/unfinished
      </button>
      <button mat-stroked-button type="button" *ngIf="isTerminal(job)" [disabled]="actionInProgress" (click)="downloadLog(job)">
        <mat-icon>download</mat-icon>
        Download log
      </button>
      <button mat-flat-button color="primary" type="button" *ngIf="isTerminal(job)" [disabled]="actionInProgress" (click)="dismiss()">
        Dismiss
      </button>
    </footer>
  </div>
</ng-container>
